module.exports = __webpack_public_path__ + "static/media/red-heart.7b9421ea.png";